import axios from "axios";
import Cookies from "js-cookie";
import error from "utils/Notifications/Error";

export const pathname: string = "http://5.188.107.131/";

export interface ValidationErrors {
    errorMessage: string;
    field_errors: Record<string, string>;
}

export const instance = axios.create({});
export const patchInstance = axios.create({
    method: "PATCH",
});

instance.interceptors.request.use((config) => {
    if (Cookies.get("access")) {
        config.headers!.Authorization = "Bearer " + Cookies.get("access");
    }
    return config;
});

patchInstance.interceptors.request.use((config) => {
    if (Cookies.get("access")) {
        config.headers!.Authorization = "Bearer " + Cookies.get("access");
    }
    return config;
});

instance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (err) => {
        const requestApiName = err.request.responseURL.split("/")[4];
        switch (err.response.status) {
            case 401:
                if (
                    err.request.responseURL.includes("auth") &&
                    window.location.href.includes("login")
                ) {
                    error("Неправильный логин или пароль");
                } else
                    error(
                        err.request.responseURL.split("/")[4] +
                            ": " +
                            err.message
                    );
                break;
            case 400:
                if (requestApiName.includes("save_logs")) {
                    error("Не удалось сохранить логи");
                }
                if (window.location.href.includes("login")) {
                    error("Неправильный логин или пароль");
                }
                break;
            default:
                error(
                    err.response.request.responseURL.split("/")[4] +
                        ": " +
                        err.message
                );
                break;
        }
        // if (err.response.status === 409 && requestApiName === "ticker") {
        // } else {
        //     error(err.response.request.responseURL.split("/")[4] + ": " + err.message)
        // }
        if (err.response.status === 401) {
            Cookies.remove("access");
            // dispatch(logOut())
        }
        if (err.response.status === 400) {
            // Cookies.remove('access')
            // dispatch(logOut())
            // console.log("400")
        }

        return Promise.reject(err);
    }
);
